// Modules
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { FormsModule } from '@angular/forms';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { IndexOfPipeModule } from 'NewAngular/features/pipes/index-of/index-of-pipe.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { TextEditModule } from 'NewAngular/features/components/modals/text-edit/text-edit.module';
import * as i0 from "@angular/core";
export class TalkingPointsEditModalModule {
}
TalkingPointsEditModalModule.ɵfac = function TalkingPointsEditModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointsEditModalModule)(); };
TalkingPointsEditModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TalkingPointsEditModalModule });
TalkingPointsEditModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        BrowserModule,
        CommonModule,
        ConfirmModalModule,
        DisabledModule,
        FormsModule,
        IconModule,
        IndexOfPipeModule,
        ModalBaseModule,
        TextEditModule] });
